import type { Profile, Topic } from '@/types/shared';

export interface BlogProps {
  title?: string;
  summary?: string;
  body?: string;
  publishedAt?: string;
  editorPublishAt?: string | null;
  scheduledPublishAt?: string | null;
  topics?: Topic[];
  authors?: Profile[];
  image?: {
    id?: string;
    url?: string;
    alt?: string;
  };
}

export enum BlogVariant {
  INLINE = 'inline',
  STACKED = 'stacked',
}
